import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInView } from 'react-intersection-observer';

import Loader from 'components/Loader';
import { PATH_ROUTES } from 'routes/path';
import ReportDetail from './ReportDetail';
import { LabReport } from 'services/interpret-lab-report/type';
import useAuthStore from 'store/auth';
import GenerateLabReport from './GenerateLabReport';
import PreviousReports from 'components/reports/PreviousReports';
import MobileReport from './MobileReport';
import { LoadMoreButton } from 'components/LoadMoreButton';
import { useInfiniteGetLabReports } from 'services/interpret-lab-report/hooks';

export default function InterpretLabReportPage() {
  const navigate = useNavigate();
  const { inView } = useInView();

  const profileId = useAuthStore((store) => store.currentUserProfileId);

  const {
    data: labReports,
    fetchNextPage,
    isFetchingNextPage,
    isLoading,
    hasNextPage,
    isFetching,
  } = useInfiniteGetLabReports(profileId, 1);

  const [selectedTokenId, setSelectedTokenId] = useState<string>('');
  const [reportData, setReportData] = useState<LabReport[]>([]);

  useEffect(() => {
    if (labReports?.length) {
      setReportData(labReports);
      setSelectedTokenId(labReports[0].token_id);
    } else {
      setReportData([]);
      setSelectedTokenId('');
    }

    if (labReports && !labReports.length) {
      navigate(PATH_ROUTES.GENERATE_LAB_REPORT);
    }
  }, [labReports]);

  useEffect(() => {
    if (inView) {
      fetchNextPage();
    }
  }, [fetchNextPage, inView, isFetching]);

  const scrollViewElement = (
    <div>
      {hasNextPage && !isFetchingNextPage ? (
        <LoadMoreButton
          onClick={() => fetchNextPage()}
          className='border-t-0'
        />
      ) : isFetchingNextPage ? (
        <Loader className='h-12' loaderSize='size-6' />
      ) : null}
    </div>
  );

  if (isLoading) return <Loader />;

  return (
    <div>
      <MobileReport
        reportData={reportData}
        setReportData={setReportData}
        scrollViewElement={scrollViewElement}
        isLoading={isLoading}
      />

      <div className='hidden px-6 pt-4 lg:block'>
        <div className='grid grid-cols-6 xl:grid-cols-5 gap-x-8'>
          <div className='col-span-2 space-y-4 xl:col-span-1'>
            <GenerateLabReport />

            <PreviousReports
              reportData={reportData}
              tokenId={selectedTokenId}
              setTokenId={setSelectedTokenId}
              setReportData={setReportData}
              scrollViewElement={scrollViewElement}
              isLoading={isLoading}
              reportType='lab'
            />
          </div>

          <div className='col-span-4'>
            <ReportDetail reportTokenId={selectedTokenId} />
          </div>
        </div>
      </div>
    </div>
  );
}
